<template>
  <v-container>
    <v-toolbar flat class="main-header mb-6 px-0">
      <v-toolbar-title class="main-header__title">
        <h1>
          <v-btn
            @click="back"
            outlined
            class="mr-3 px-0 m-w-50"
            large
            color="primary"
            ><v-icon>mdi-arrow-left</v-icon></v-btn
          >
          Choices
        </h1>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-toolbar-items class="main-header__contents">
        <v-btn
          class="my-auto mx-1 radius-12"
          color="success"
          :to="{
            name: 'choiceCreate',
            query: { question: this.$route.query.question }
          }"
        >
          <v-icon>mdi-plus-circle</v-icon>
          <span class="mx-2">New Choice</span>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <!-- <p v-if="choices.length > 0" v-html="choices[0].question.body"></p> -->
    <hr class="mb-6" />
    <v-data-table
      :headers="headers"
      :loading="loadingDataTable"
      :items="choices"
      :mobile-breakpoint="zero"
      :items-per-page="200"
      hide-default-footer
      class="table teams"
    >
      <template v-slot:item="{ item, index }">
        <tr class="table__row">
          <td class="table__cell name text-center">
            <read-more
              more-str="more"
              less-str="less"
              :text="item.value || '---'"
              :max-chars="15"
              class="mb-0 major-description m-b-0"
            ></read-more>
          </td>
          <td class="table__cell text-center transparent-field">
            <v-checkbox
              v-model="item.visible"
              color="warning"
              @change="choiceVisiblity(item)"
            ></v-checkbox>
          </td>
          <td class="table__cell text-center">
            <router-link
              :to="{ name: 'phaseQuestions', query: { choice: item.id } }"
            >
              <v-icon>mdi-open-in-app</v-icon>
            </router-link>
          </td>
          <td class="table__cell text-center">
            <router-link
              :to="{ name: 'choiceEdit', params: { id: item.id } }"
              class="hovering mr-3 edit"
            >
              <v-icon small>mdi-pencil</v-icon><br />
              Edit
            </router-link>

            <span @click="handleDelete(item, index)" class="hovering delete">
              <v-icon small>mdi-delete</v-icon><br />
              Delete
            </span>
          </td>
        </tr>
      </template>
    </v-data-table>
    <!-- pagination -->
    <div class="text-xs-center pt-2">
      <v-pagination
        v-if="choices.length > 0 && pagination.last_page > 1"
        v-model="pagination.current_page"
        :length="pagination.last_page"
        :total-visible="20"
        @input="handlePagination"
      ></v-pagination>
    </div>
    <!-- pagination -->
  </v-container>
</template>

<script>
import TableHeaders from "@/helpers/TableHeaders";
import { IndexData, UpdateData, DeleteData } from "@/helpers/apiMethods";
import { mapGetters } from "vuex";
import { isEqual } from "lodash";

export default {
  data() {
    return {
      zero: 0,
      appData: {},
      dialog: false,
      priority: false,
      loading: false,
      headers: [],
      choices: [],
      appTypechoices: [],
      pagination: {},
      queries: {},
      loadingDataTable: false
    };
  },
  computed: {
    ...mapGetters({
      permissions: "permissions"
    })
  },
  created() {
    this.createTableHeaders();
    // this.indexchoices();
  },
  methods: {
    indexChoices(query) {
      this.loadingDataTable = true;
      IndexData({ reqName: `hr/choices`, query })
        .then(res => {
          const { data, meta } = res.data;
          this.choices = data;
          this.pagination = meta;
          this.loadingDataTable = false;
        })
        .catch(() => {})
        .finally(() => {});
    },
    createTableHeaders() {
      const headersList = [
        "Choice Value",
        "Visibility",
        "Questions",
        "Actions"
      ];
      this.headers = TableHeaders(headersList);
    },
    closeDialog() {
      this.dialog = false;
      this.appTypechoices = [];
    },
    closePriorityDialog() {
      this.priority = false;
      this.appData = {};
    },
    handleDelete({ id }, index) {
      this.popUp().then(value => {
        if (!value.dismiss) {
          DeleteData({
            reqName: `/hr/choices`,
            id: id
          })
            .then(() => {
              this.choices.splice(index, 1);
            })
            .catch(() => {});
        }
      });
    },
    choiceVisiblity(item) {
      UpdateData({
        reqName: `hr/choices`,
        data: { visible: item.visible, _method: "PUT" },
        id: item.id
      })
        .then(() => {})
        .catch(() => {})
        .finally(() => {});
    },
    handlePagination(page) {
      this.queries = { ...this.queries, page };
      if (!isEqual(this.queries, this.$route.query)) {
        this.$router.push({ query: this.queries });
      }
    },
    back() {
      history.go(-1);
    }
  },
  watch: {
    $route: {
      handler({ query }) {
        this.queries = query;
        this.indexChoices(this.queries);
      },
      immediate: true
    }
  }
};
</script>
